import React from "react";

import InvoiceGrid from "pages/invoices/component/invoice.grid";
import {downloadInvoicePdf, getInvoiceDataSource, Invoice, InvoiceStatus} from "pages/invoices/invoices.service";

import ActionsPanelComponent from "components/dxf-grid/actions-panel.component";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useMutation} from "react-query";

const CanceledInvoicePage = () => {
  const dataSource = React.useMemo(() => getInvoiceDataSource(InvoiceStatus.Cancelled), []);
  return <InvoiceGrid dataSource={dataSource} actions={InvoiceActions} invoiceStatus="canceled" />;
};

function InvoiceActions({ data }: any) {
  const {t} = useTranslation('invoices');
  const navigate = useNavigate();

  const downloadPdfMutation = useMutation(() => downloadInvoicePdf(data as Invoice))


  const actions = [
    {
      label: t('download'),
      action: () => downloadPdfMutation.mutate()
    },
    {
      label: t('need-help-with-invoice'),
      action: () => navigate('/tickets',{state:{isAddingTicket:true,invoice:data}})
    }
  ];
  return <ActionsPanelComponent actions={actions} isLoading={downloadPdfMutation.isLoading} />;
}

export default CanceledInvoicePage;
